import { setFilter } from "../tradeByProductsUXSlice";
import { setData } from "../tradeByProductsDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import React from "react";
import { TradeByProductsReportFilter } from "../types";
import { useCopiedState } from "../../../../../core/util/hooks";

export const useTradeByProductsReportFilter = () => {
  const storeFilter = useSelector<StoreType, TradeByProductsReportFilter>(
    (store) => store.ux.reports.exchbusiness.tradeByProducts.filter
  );
  const [filter, editFilter] = useCopiedState<TradeByProductsReportFilter>(
    storeFilter
  );

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(setData());
  }, [dispatch, filter]);

  return [filter, editFilter, dispatchSetFilter] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter
  ];
};
